'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Table } from '../Table';
import type { ColumnDef } from './types';
interface DataTableSkeletonProps<T> {
  columns: ColumnDef<T>[];
  rowCount: number;
  selectionMode?: 'none' | 'multiple';
  hasRowActions?: boolean;
  cellPaddingX?: string;
}
export function DataTableSkeleton(t0) {
  const $ = _c(11);
  const {
    columns,
    rowCount,
    selectionMode: t1,
    hasRowActions: t2,
    cellPaddingX: t3
  } = t0;
  const selectionMode = t1 === undefined ? "none" : t1;
  const hasRowActions = t2 === undefined ? false : t2;
  const cellPaddingX = t3 === undefined ? "px-6" : t3;
  let t4;
  if ($[0] !== cellPaddingX || $[1] !== columns || $[2] !== hasRowActions || $[3] !== rowCount || $[4] !== selectionMode) {
    let t5;
    if ($[6] !== cellPaddingX || $[7] !== columns || $[8] !== hasRowActions || $[9] !== selectionMode) {
      t5 = (_, i) => <Table.Row key={i} className="animate-pulse">{selectionMode === "multiple" && <Table.Cell className={`min-h-[67px] justify-center py-3 ${cellPaddingX}`}><div className="h-4 w-4 rounded bg-neutral-200" /></Table.Cell>}{columns.map(col => <Table.Cell key={col.id} className={`min-h-[67px] py-3 ${cellPaddingX} ${col.cellClassName ?? ""}`}><div className="h-4 w-full max-w-[140px] rounded bg-neutral-200" /></Table.Cell>)}{hasRowActions && <Table.Cell className={`min-h-[67px] justify-end py-3 ${cellPaddingX}`}><div className="h-8 w-8 rounded-lg bg-neutral-100" /></Table.Cell>}</Table.Row>;
      $[6] = cellPaddingX;
      $[7] = columns;
      $[8] = hasRowActions;
      $[9] = selectionMode;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = <>{Array.from({
        length: rowCount
      }, t5)}</>;
    $[0] = cellPaddingX;
    $[1] = columns;
    $[2] = hasRowActions;
    $[3] = rowCount;
    $[4] = selectionMode;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}